<template>
  <div class="row dist-top">
    <div class="col-md-6">
      <div v-if="$store.state.domain !== 'jedno'" class="media">
        <div class="media-left">
          <img
            class="media-object"
            src="@/assets/pdf.png"
            alt="pdf icon">
        </div>
        <div class="media-body file-list">
          <header>Vyplnené tlačivá:</header>
          <!--p>
            <strong>
              danové priznanie.pdf
            </strong>
            <b-button
              @click="hrefProcess(`/fo/download/pdf?id=${$route.params.userId}`)"
              :class="`download-button pull-right${ $store.state.subjectType === 'b' ? '' : ''}`">
              {{ $t('message.wizPage5') }}
            </b-button>
          </p-->
          <p>
            <strong>potvrdenie.pdf</strong>
            <b-button
              class="download-button pull-right"
              @click="hrefProcess(`/fo/download/potvrdenie?id=${$route.params.userId}`)">
              {{ $t('message.wizPage5') }}
            </b-button>
          </p>
          <p v-if="$store.state.subjectType === 'b'">
            <strong>{{ $t('message.lblPredNaDan') }}</strong>
            <b-button
              class="download-button pull-right"
              @click="hrefProcess(`/fo/print/preddavok?id=${$route.params.userId}`)">
              {{ $t('message.wizPage5') }}
            </b-button>
          </p>
          <p v-if="urlCheck()">
            <strong>ppd</strong>
            <b-button
              class="download-button pull-right"
              @click="hrefProcess(`/ppd?id=${id}`)">
              {{ $t('message.wizPage5') }}
            </b-button>
          </p>
          <p v-if="urlCheck()">
            <strong>čestné vyhlásenie.pdf</strong>
            <b-button
              class="download-button pull-right"
              @click="hrefProcess(`/fo/download/cestne?id=${$route.params.userId}`)">
              {{ $t('message.wizPage5') }}
            </b-button>
          </p>
        </div>
      </div>

      <div class="media" style="margin-top: 2rem">
        <div class="media-left">
          <img
            class="media-object"
            src="@/assets/xml.png"
            alt="xml icon">
        </div>
        <div class="media-body file-list">
          <header>XML dáta:</header>
          <p>
            <strong>danové priznanie.xml</strong>
            <b-button
              class="download-button pull-right"
              @click="hrefProcess(`/fo/download/xml?id=${$route.params.userId}`)">
              {{ $t('message.wizPage5') }}
            </b-button>
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <bubble-message
        :message="upozornenie"
        :img="false"
      />
      <!--bubble-message
        class="alert-message"
        :message="noFileInFinancnaMessage"
        :img="false"
      /-->

      <div class="help-bubble triangle-right right" style="display: block;">
        <div class="shadow6">
          <div class="media">
            <div class="media-left"/>
            <div class="media-body">
              Súbor XML môžete nahrať do
              <a
                :href="financnaLink()"
                target="_blank">
                elektronického formulára
              </a>
              Daňového úradu a môžete si tak skontrolovať, že sú vyplnené a vypočítané
              údaje bezchybné.
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="$store.state.activeMembership === 0 && !urlCheck()"
        class="help-bubble triangle-right right donateBubble">
        <div
          class="media"
          style="margin-top: 0.5em">
          <div class="media-left">
            <img
              class="media-object"
              src="@/assets/bullet.png">
          </div>
          <div class="media-body">
            <div class="col-md-12">
              Vážený užívateľ, ďakujeme že ste si zvolili našu stránku www.jednoduche.sk na
              vyplnenie Vášho daňového priznania. Ak nemáte zaplatený niektorý z balíkov a
              páči sa Vám, ako funguje náš portál, prispejte nám na jeho rozvoj vybratím
              niektorej sumy z ponuky, prosím.<br>Ďakujeme!
            </div>
            <div class="row">
              <div class="col-md-8"/>
              <div class="col-md-4">
                <b-button
                  style="margin-bottom: 0.5em"
                  size="sm"
                  class="download-button"
                  v-b-modal.donate>
                  {{ buttonItems.label }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <donate-modal />
  </div>
</template>

<script>
import bubbleMessage from '@/components/bubbleMessage.vue';
import restEditor from '@/mixins/restEditor';
import donateModal from '@/components/donateModal.vue';

export default {
  components: {
    bubbleMessage,
    donateModal,
  },

  mixins: [restEditor],

  data() {
    return {
      upozornenie: this.$t('message.downloadHelp1'),
      este_pracujeme: 'Na danové prizninie typ B ešte nedostupné',
      noFileInFinancnaMessage: 'Súbory môžete stiahnuť po uverení aktuálnych PDF resp. xml súborov na portáli <a href="www.financnasprava.sk">www.financnasprava.sk</a>',
      buttonItems: {
        label: 'PRISPEJEM',
        vB: 'donate',
      },
      id: null,
      url: null,
    };
  },

  methods: {
    async processGet() {
      this.url = document.URL;
      if (this.urlCheck()) {
        this.id = await this.restDataSource.getData(`${this.$route.params.userId}/ppd`, 'subjects');
      }
    },
    async processSave() {
      return null;
    },
    urlCheck() {
      if (this.$store.state.domain === '!jedno') {
        return true;
      }
      return false;
    },
    financnaLink() {
      let link = null;
      if (this.$store.state.subjectType === 'b') {
        link = 'https://pfseform.financnasprava.sk/Formulare/eFormVzor/DP/form.495.html';
      } else if (this.$store.state.subjectType === 'a') {
        link = 'https://pfseform.financnasprava.sk/Formulare/eFormVzor/DP/form.497.html';
      }
      return link;
    },

    hrefProcess (l, connected = 1) {
      if (connected) {
       window.location.href = l;        
      }
    }
  },
};
</script>

<style>
.download-button {
  color: #fff;
  background-color: #19baa9;
  border: none;
  text-transform: uppercase;
  border-radius: 0;
  float:left;
  padding: 5px 10px;
}
.download-button:hover {
  color: #fff;
  background-color: #29cab9;
}
@keyframes blinker {
  50% {
    opacity: 0.7;
  }
}
.donateBubble {
  display: block;
  animation: blinker 1s 8;
  animation-delay: 3s;
}
.alert-message {
  background-color: #a94442!important;
}
.alert-message.triangle-right::after {
  border-color: transparent #a94442!important;
}

.file-list p {
  display: flex;
  justify-content: space-between;
  margin-bottom: .4rem;
  font-size: 16px;
}

.file-list header {
  margin-bottom: 1.5rem;
}

.file-list strong {
  margin: auto 0;
}

.file-list button {
  font-size: .9rem;
}

.dist-top.xml {
  margin-top: 4rem;
}

.help-bubble a:hover {
  text-decoration: underline;
}
</style>
